export default __webpack_public_path__ + "static/media/Gallery-10.2daf034e.jpeg";